var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "tools-strip" }, [
        _vm.globalIsUserAllowed("Google_Street_View")
          ? _c(
              "button",
              {
                staticClass: "tool-btn",
                class: { "tool-btn--active": _vm.showStreetView },
                attrs: { title: "Google Street View" },
                on: {
                  click: function ($event) {
                    return _vm.toggleStreetView()
                  },
                },
              },
              [
                _c("fa", {
                  attrs: { icon: ["fas", "street-view"], size: "sm" },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.globalIsUserAllowed("ANSI_Feature_Table")
          ? _c(
              "button",
              {
                staticClass: "tool-btn",
                attrs: { title: "Feature Table" },
                on: {
                  click: function ($event) {
                    return _vm.initFeatureTable()
                  },
                },
              },
              [_c("fa", { attrs: { icon: ["fas", "table"], size: "sm" } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.globalIsUserAllowed("ANSI_Reports")
          ? _c(
              "button",
              {
                staticClass: "tool-btn",
                attrs: { title: "Reports" },
                on: {
                  click: function ($event) {
                    return _vm.initANSIReports()
                  },
                },
              },
              [_c("fa", { attrs: { icon: ["fas", "chart-pie"], size: "sm" } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.mmp_layersObj["Otonomo"] && _vm.globalIsUserAllowed("Otonomo")
          ? _c(
              "button",
              {
                staticClass: "tool-btn",
                class: { "tool-btn--active": _vm.checkForActiveOtonomoLayer() },
                attrs: {
                  disabled: !_vm.isNorthAmericaExtent,
                  title: _vm.isNorthAmericaExtent
                    ? "Otonomo"
                    : "Otonomo is only available for North America",
                },
                on: {
                  click: function ($event) {
                    return _vm.openOtonomo()
                  },
                },
              },
              [_c("fa", { attrs: { icon: ["fas", "road"], size: "sm" } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.mmp_layersObj["Otonomo"] &&
        _vm.globalIsUserAllowed("Otonomo_Status")
          ? _c(
              "button",
              {
                staticClass: "tool-btn",
                class: { "tool-btn--active": _vm.showPopup },
                attrs: { title: "Draw Selection" },
                on: {
                  click: function ($event) {
                    return _vm.enableDraw()
                  },
                },
              },
              [_c("fa", { attrs: { icon: ["fas", "crop"], size: "sm" } })],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("MMP_ANSI_Otonomo", {
        attrs: {
          previousSelectedSubcountry: _vm.previousSelectedSubcountry,
          view: _vm.map.getView(),
        },
        on: {
          enableOtonomoLayer: function ($event) {
            return _vm.enableOtonomoLayer($event)
          },
          subcountryChanged: function ($event) {
            return _vm.$emit("subcountryChanged")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }